import DraggableBase, { DraggableProps } from "react-draggable";
import type { FC, PropsWithChildren } from "react";

// react-draggable 4.4.x declares DraggableProps relying on defaultProps.
// Newer @types/react drops defaultProps inference, marking every prop required.
// Re-type as all-optional to keep usage like <Draggable>{...}</Draggable> valid.
const Draggable = DraggableBase as unknown as FC<
  PropsWithChildren<Partial<DraggableProps>>
>;

export default Draggable;
